const angular = require('angular');

const PackagingPreferenceService = require('./packaging-preference.service');

angular.module('wowApp.shop')
    .service('PackagingPreferenceService', PackagingPreferenceService);



// WEBPACK FOOTER //
// ./src/order/packaging/index.js